import { CDNPathUtil } from "../../../base/util/CDNPathUtil";
import { DarkTheme } from "./DarkTheme";
export class BgFTheme {
}
BgFTheme.theme = {
    saasAiAppTheme: {
        ...DarkTheme.theme.saasAiAppTheme,
        background: `url(${CDNPathUtil.getFilePath("themeBgF.jpg")})`,
    },
    nodeTheme: {
        ...DarkTheme.theme.nodeTheme,
    },
    appSignUpButtonTheme: {
        ...DarkTheme.theme.appSignUpButtonTheme,
    },
    patchTheme: {
        inputBorder: "0",
        inputBorderBottom: "0",
        inputPadding: "15px 25px",
        renderingTransitionColors: "#1a142d",
    },
};
